(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csw-fitment-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-csw-fitment-check]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-fitment-form]');
    const status = root.querySelector('[data-fitment-status]');
    const result = root.querySelector('[data-fitment-result]');
    const output = root.querySelector('[data-fitment-result-content]');
    const endpoint = root.dataset.endpoint?.trim();
    const text = (parent, tag, value, className = '') => { const node = document.createElement(tag); node.textContent = value || ''; if (className) node.className = className; parent.append(node); return node; };
    const renderGroup = (parent, heading, recommendations, emptyMessage, className = '') => {
      const group = document.createElement('section');
      group.className = `csw-fitment-check__report-group ${className}`.trim();
      text(group, 'h3', heading, 'csw-fitment-check__report-group-heading');
      if (!recommendations.length) { text(group, 'p', emptyMessage, 'csw-fitment-check__empty'); parent.append(group); return; }
      const grid = document.createElement('div'); grid.className = 'csw-fitment-check__report-grid';
      recommendations.forEach((item, index) => {
        const card = document.createElement('article'); card.className = 'csw-fitment-check__report';
        text(card, 'h4', item.label || `Option ${index + 1}`);
        const specs = document.createElement('dl');
        [['Diameter', item.diameter], ['Width', item.width], ['Offset', item.offset], ['Bolt pattern', item.bolt_pattern], ['Centre bore', item.center_bore], ['Tire starting point', item.tire_size]].forEach(([label, value]) => { if (!value) return; text(specs, 'dt', label); text(specs, 'dd', value); });
        card.append(specs); if (item.notes) text(card, 'p', item.notes, 'csw-fitment-check__report-note'); grid.append(card);
      });
      group.append(grid); parent.append(group);
    };
    const report = (data) => {
      output.replaceChildren();
      if (data.vehicle_summary) text(output, 'p', data.vehicle_summary, 'csw-fitment-check__summary');
      if (data.source_status === 'ai_generated_unverified') text(output, 'p', 'AI-generated guidance. Confirm OEM specifications against your vehicle documentation before ordering.', 'csw-fitment-check__summary');
      let oem = Array.isArray(data.oem_recommendations) ? data.oem_recommendations : [];
      let aggressive = Array.isArray(data.aggressive_recommendations) ? data.aggressive_recommendations : [];
      // Keep older endpoint responses readable while the service adopts the two-tier contract.
      if (!oem.length && !aggressive.length && Array.isArray(data.recommendations)) {
        oem = data.recommendations.filter((item) => item.tier === 'oem' || item.category === 'oem');
        aggressive = data.recommendations.filter((item) => item.tier === 'aggressive' || item.category === 'aggressive');
        if (!oem.length && !aggressive.length) oem = data.recommendations;
      }
      if (!oem.length && !aggressive.length) { text(output, 'p', data.vehicle_found === false ? 'No reliable OEM specifications were found. Please check the vehicle details or contact us.' : 'No fitment recommendation was returned. Please review the vehicle details and try again.', 'csw-fitment-check__empty'); result.hidden = false; return; }
      renderGroup(output, 'OEM FITMENT', oem, 'No OEM fitment was returned for this vehicle.');
      renderGroup(output, 'SUGGESTED AGGRESSIVE FITMENT', aggressive, 'No more aggressive option was returned for this vehicle.', 'csw-fitment-check__report-group--aggressive');
      text(output, 'p', data.aggressive_disclaimer || 'Suggested aggressive fitment is informational only. Independently verify wheel and tire fitment, clearances and vehicle modifications before ordering.', 'csw-fitment-check__disclaimer');
      result.hidden = false; result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      if (!endpoint) { status.textContent = 'The fitment analysis connection is not configured yet. Your form is ready for the vehicle data service.'; status.dataset.type = 'error'; return; }
      const submit = form.querySelector('[type="submit"]'); submit.disabled = true; status.textContent = 'Checking vehicle fitment...'; status.dataset.type = '';
      try {
        const response = await fetch(endpoint, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(Object.fromEntries(new FormData(form).entries())) });
        if (!response.ok) throw new Error('Fitment service unavailable');
        const data = await response.json();
        if (!Array.isArray(data.oem_recommendations) || !Array.isArray(data.aggressive_recommendations)) throw new Error('Invalid fitment response');
        report(data); status.textContent = data.vehicle_found === false ? 'No reliable fitment data found for this vehicle.' : 'Fitment report ready.'; status.dataset.type = data.vehicle_found === false ? 'error' : 'success';
      } catch (error) { status.textContent = 'We could not complete the fitment check right now. Please try again shortly.'; status.dataset.type = 'error'; } finally { submit.disabled = false; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
